import { useMediaQuery } from 'react-responsive';

import { WAIVE_COLD_PACK_FEE_MIN } from 'constants/shop';
import Button from 'honeydew/Button';
import { Drawer } from 'honeydew/Drawer';
import Modal from 'honeydew/Modal';
import useTailwindTheme from 'hooks/useTailwindTheme';

/**
 * @param {Object} props - Component props
 * @param {Function} props.handleClose - Function to call when the modal should be closed
 * @param {boolean} props.open - Whether the modal is currently open
 */
function ColdPackFeeModal({ coldPackFee, handleClose, open }) {
    const tailwindTheme = useTailwindTheme();
    const mobile = useMediaQuery({ maxWidth: tailwindTheme?.screens?.md });

    return mobile ? (
        <Drawer
            anchor="bottom"
            open={open}
            PaperProps={{ sx: { borderRadius: '20px 20px 0 0', padding: '20px' } }}
            toggleDrawer={() => handleClose()}
        >
            <div className="mb-20 flex flex-col gap-10">
                <ModalHeading coldPackFee={coldPackFee} />
                <ModalContent />
            </div>
            <Button onClick={() => handleClose()}>Got it</Button>
        </Drawer>
    ) : (
        <Modal headline={<ModalHeading coldPackFee={coldPackFee} />} open={open} onClose={() => handleClose()}>
            <ModalContent />
        </Modal>
    );
}

function ModalHeading({ coldPackFee }) {
    return (
        <h2 className="text-body-md font-grotesk-bold">
            <div className="flex items-center justify-between gap-5">
                <div>Cold Pack Fee</div>
                <div>${coldPackFee.toFixed(2)}</div>
            </div>
        </h2>
    );
}

function ModalContent() {
    return (
        <p className="text-body-mobile-xs text-grey md:text-body-mobile-sm">
            Packaging fee may apply to keep items like meat, seafood, and dairy refrigerator-cold in transit. Fee will
            be waived if ${WAIVE_COLD_PACK_FEE_MIN}+ of Cold Pack items are ordered.
        </p>
    );
}

export default ColdPackFeeModal;
